<div class="app-main {{checkId3Confirm()?'hidden heigh-1':''}}" style="font-family: TitilliumWeb-Regular!important;">
  <app-header *ngIf="!hideSiteControls"></app-header>
  <div class="app-content">
    <router-outlet></router-outlet>
  </div>
  <app-footer *ngIf="!hideSiteControls"></app-footer>
</div>
<div *ngIf="checkId3Confirm()" style="margin-top: 150px">
  <app-loading-component></app-loading-component>
</div>
